const masterEn = {
    course: require('../../lang/en/master/Course').default,
    country: require('../../lang/en/master/Country').default,
    city: require('../../lang/en/master/City').default,
    district: require('../../lang/en/master/District').default,
    pin: require('../../lang/en/master/Pin').default,
    place: require('../../lang/en/master/Place').default,
    state: require('../../lang/en/master/State').default,
    tehsil: require('../../lang/en/master/Tehsil').default,
    session: require('../../lang/en/master/Session').default,
    semester: require('../../lang/en/master/Semester').default,
    student: require('../../lang/en/master/Student').default,
    subject: require('../../lang/en/master/Subject').default,
    designation: require('../../lang/en/master/Designation').default,
    department: require('../../lang/en/master/Department').default,
    slot: require('../../lang/en/master/Slot').default,
    paymentMaster: require('../../lang/en/master/PaymentMaster').default,
    staff: require('../../lang/en/master/Staff').default,
    topic: require('../../lang/en/master/Topic').default,
    coupon: require('../../lang/en/master/Coupon').default,
};

export default masterEn;